export const GET_CONTACTS_US_REQUEST = "GET_CONTACTS_US_REQUEST";
export const GET_CONTACTS_US_SUCCESS = "GET_CONTACTS_US_SUCCESS";
export const GET_CONTACTS_US_FAILURE = "GET_CONTACTS_US_FAILURE";
